import React from 'react';
import { TouchableOpacity, StyleSheet, Text, View } from 'react-native';
import { useLanguage } from '@/contexts/LanguageContext';
import Svg, { Path } from 'react-native-svg';

interface LanguageButtonProps {
  style?: any;
}

export default function LanguageButton({ style }: LanguageButtonProps) {
  const { language, setLanguage } = useLanguage();

  console.log('🌍 LanguageButton Debug:', {
    language,
    languageType: typeof language,
    upperCase: language?.toUpperCase(),
    hasLanguage: !!language
  });

  const toggleLanguage = () => {
    import('expo-haptics')
      .then((Haptics) =>
        Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light)
      )
      .catch(() => {});
    // Cycle through PT -> EN -> ES -> PT
    const languages: Array<'pt' | 'en' | 'es'> = ['pt', 'en', 'es'];
    const currentIndex = languages.indexOf(language);
    const nextIndex = (currentIndex + 1) % languages.length;
    const nextLanguage = languages[nextIndex];
    if (nextLanguage) {
      setLanguage(nextLanguage);
    }
  };

  return (
    <TouchableOpacity 
      style={[styles.button, style]} 
      onPress={toggleLanguage}
      activeOpacity={0.7}
    >
      <View style={styles.iconContainer}>
        <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <Path 
            fillRule="evenodd" 
            clipRule="evenodd" 
            d="M12 3C16.9709 3 21 7.02908 21 12C21 16.9709 16.9709 21 12 21C7.02908 21 3 16.9709 3 12C3 7.02908 7.02908 3 12 3Z" 
            stroke="#151515" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
          />
          <Path 
            fillRule="evenodd" 
            clipRule="evenodd" 
            d="M11.9994 3C13.85 3 15.3493 7.02908 15.3493 12C15.3493 16.9709 13.85 21 11.9994 21C10.1488 21 8.64941 16.9709 8.64941 12C8.64941 7.02908 10.1488 3 11.9994 3Z" 
            stroke="#151515" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
          />
          <Path 
            d="M3 11.998H21" 
            stroke="#151515" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
          />
        </Svg>
      </View>
      <View style={styles.spacer} />
      <Text style={styles.languageText}>{language.toUpperCase()}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    height: 48,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 24,
    borderWidth: 1,
    borderColor: '#DAD8CF',
    backgroundColor: '#FFFFFF',
  },
  iconContainer: {
    width: 24,
    height: 24,
  },
  spacer: {
    width: 8,
  },
  languageText: {
    color: '#151515',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 19.6, // 140% of 14px
  },
});
